import { create } from 'zustand';

interface RegionAvailability {
  unavailable: boolean;
  setUnavailable(unavailable: boolean): void;
}

export const useRegionAvailability = create<RegionAvailability>((set) => ({
  unavailable: false,
  setUnavailable: (unavailable) => set({ unavailable }),
}));

export async function regionFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const response = await fetch(input, init);
  if (
    response.status === 404 &&
    response.headers.get('content-type')?.toLowerCase().includes('application/json')
  ) {
    let body: unknown;
    try {
      body = await response.clone().json();
    } catch (error) {
      if (!(error instanceof SyntaxError)) throw error;
      console.warn('Could not inspect the invalid API error response.', error);
    }
    if (
      typeof body === 'object' &&
      body !== null &&
      'error' in body &&
      body.error === 'Region is unavailable'
    ) {
      useRegionAvailability.getState().setUnavailable(true);
    }
  }
  return response;
}
